var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择国家"},on:{"change":_vm.handleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.label,attrs:{"label":item.value,"value":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }